var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagTurkmenistan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16715)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 0.850586C14.8053 0.850586 13.6416 0.982648 12.5217 1.2309L11.8261 16.8505L12.5217 32.4702C13.6417 32.7185 14.8054 32.8506 15.9999 32.8506C24.8365 32.8506 31.9999 25.6871 31.9999 16.8505C31.9999 8.01402 24.8365 0.850586 15.9999 0.850586V0.850586Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17394 6.07373C1.58119 8.91723 6.10352e-05 12.6991 6.10352e-05 16.8505C6.10352e-05 21.0019 1.58125 24.7837 4.174 27.6274L4.86962 16.8505L4.17394 6.07373Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4008 12.9193C24.188 10.7252 23.3036 8.33889 21.4057 7.15039C21.7471 7.19483 22.0888 7.2752 22.4261 7.39614C24.9575 8.30439 26.2734 11.0926 25.3651 13.624C24.4569 16.1556 21.6686 17.4713 19.1372 16.5631C18.7999 16.4421 18.485 16.2868 18.1933 16.1041C20.4139 16.3933 22.6136 15.1135 23.4008 12.9193Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0357 6.54883L18.3517 7.4327L17.2998 7.05527L17.929 7.97889L17.245 8.86264L18.3178 8.54977L18.9471 9.47327L18.9808 8.35627L20.0537 8.04333L19.0019 7.66602L19.0357 6.54883Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8822 9.42871L20.1982 10.3125L19.1463 9.93509L19.7755 10.8587L19.0915 11.7425L20.1643 11.4295L20.7936 12.3531L20.8274 11.2361L21.9002 10.9231L20.8484 10.5457L20.8822 9.42871Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7788 7.59766L15.0947 8.48141L14.0429 8.10409L14.6721 9.02766L13.9881 9.91147L15.0608 9.59853L15.6901 10.5221L15.7239 9.40509L16.7968 9.09216L15.7449 8.71472L15.7788 7.59766Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7037 10.8965L15.0197 11.7803L13.9679 11.4029L14.5971 12.3265L13.913 13.2103L14.9859 12.8974L15.6151 13.8209L15.6489 12.7039L16.7218 12.391L15.6699 12.0135L15.7037 10.8965Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8424 12.0229L18.1584 12.9067L17.1065 12.5293L17.7358 13.4529L17.0517 14.3366L18.1246 14.0238L18.7538 14.9474L18.7876 13.8303L19.8605 13.5174L18.8085 13.14L18.8424 12.0229Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17395 6.07383V27.6274C6.35395 30.0183 9.24958 31.7448 12.5218 32.4702V1.23096C9.24951 1.95633 6.35401 3.68289 4.17395 6.07383Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35957 9.27471L5.96201 8.23359V6.76128L7.35957 5.72021H9.33613L10.7337 6.76128V8.23359L9.33613 9.27471H7.35957Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34788 5.72021H7.35957L5.96201 6.76128V7.48109H8.34788V5.72021Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34787 9.27461H9.33612L10.7337 8.23348V7.48242H8.34787V9.27461Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35957 27.9808L5.96201 26.9396V25.4674L7.35957 24.4263H9.33613L10.7337 25.4674V26.9396L9.33613 27.9808H7.35957Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34788 24.4263H7.35957L5.96201 25.4674V26.1872H8.34788V24.4263Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34787 27.9806H9.33612L10.7337 26.9395V26.1885H8.34787V27.9806Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35957 18.6277L5.96201 17.5866V16.1144L7.35957 15.0732H9.33613L10.7337 16.1144V17.5866L9.33613 18.6277H7.35957Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7826 20.9183H10.1739V20.3096H9.10418L8.3478 19.5532L7.59149 20.3096H6.5218V20.9183H5.91312V22.1357H6.5218V22.7443H7.59143L8.34787 23.5008L9.10418 22.7443H10.1739V22.1357H10.7826V20.9183Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7826 11.5653H10.1739V10.9566H9.10418L8.3478 10.2002L7.59149 10.9566H6.5218V11.5653H5.91312V12.7827H6.5218V13.3914H7.59143L8.34787 14.1479L9.10418 13.3914H10.1739V12.7827H10.7826V11.5653Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65213 16.1548H9.04344V17.5461H7.65213V16.1548Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34775 12.8693C8.73194 12.8693 9.04338 12.5578 9.04338 12.1737C9.04338 11.7895 8.73194 11.478 8.34775 11.478C7.96357 11.478 7.65213 11.7895 7.65213 12.1737C7.65213 12.5578 7.96357 12.8693 8.34775 12.8693Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34775 22.2228C8.73194 22.2228 9.04338 21.9114 9.04338 21.5272C9.04338 21.143 8.73194 20.8315 8.34775 20.8315C7.96357 20.8315 7.65213 21.143 7.65213 21.5272C7.65213 21.9114 7.96357 22.2228 8.34775 22.2228Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16715"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.850586)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagTurkmenistan);
export default __webpack_public_path__ + "static/media/flag_turkmenistan.624943dc1a09023b9bc5f51541e5810d.svg";
export { ForwardRef as ReactComponent };